import * as React from 'react';
import * as I18nAPI from '../api/i18n';
const BettingTypeTitle = ({ sport, bettingType }) => {
    return (React.createElement(React.Fragment, null, I18nAPI.translate('common', `bettingType-${bettingType}-${sport}`) ||
        I18nAPI.translate('common', `bettingType-${bettingType}`)));
};
export default BettingTypeTitle;
//# sourceMappingURL=BettingTypeTitle.js.map